import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Component, OnInit, signal } from '@angular/core';

import { MessageService } from 'primeng/api';
import { ResetPasswordFormComponent } from '../../components/forms/reset-password-form/reset-password-form.component';
import { UserService } from '../../services/user/user.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-reset-password',
  imports: [
    ResetPasswordFormComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  readonly isLoading = signal<boolean>(false);

  readonly token = signal<string>('');
  constructor(private readonly router: Router,
    private readonly route: ActivatedRoute,

    private readonly userService: UserService,
    private readonly messageService: MessageService) { }

  resetPassword(fields: { password: string; }) {
    const { password } = fields;
    console.log('Resetting password for token:', this.token());
    this.userService.resetPassword(this.token(), password)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (res: any) => {
          console.log(res)
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Senha alterada com sucesso! Faça login novamente.',
            life: 4000
          });
          this.router.navigate(['/login']);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha na alteração da senha! Tente novamente mais tarde.',
            life: 4000
          });
        }
      });
  }

    ngOnInit(): void {
      if(!this.route.snapshot.paramMap.get('token')){
        this.router.navigate(['/login']);
      }

      this.token.set(this.route.snapshot.paramMap.get('token') ?? '');
    }
}
